import Hero from './components/Hero';
import About from './components/About';
import Solutions from './components/Solutions';
import TechnologyApproach from './components/TechnologyApproach';
import Impact from './components/Impact';
import Projects from './components/Projects';
import Timeline from './components/Timeline';
import Contact from './components/Contact';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navigation />
      <Hero />
      <About />
      <Solutions />
      <TechnologyApproach />
      <Impact />
      <Projects />
      <Timeline />
      <Contact />
      <Footer />
    </div>
  );
}
